import React from 'react';
import { Extension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Plugin } from 'prosemirror-state';
import { Fragment, Slice } from 'prosemirror-model';
import ExternalLinkExtension, { ExternalLinkView } from '../../pages/reaction/ReactionEditor/ExternalLinkExtension';
import { bioLinkLabel } from '../../utils/aboutLinks';
import { CONTENT_LIMITS } from '../../utils/contentLimits';
import { bioPasteNodes, serializeBioContent, serializeBioDoc } from './model';

function BioLinkView(props) {
  return <ExternalLinkView {...props} displayLabel={bioLinkLabel(props.node.attrs)} />;
}

const breaksIn = value => value.split('\n').length - 1;
const availableBreaks = state => Math.max(0, CONTENT_LIMITS.aboutLines - 1
  - breaksIn(serializeBioDoc(state.doc))
  + breaksIn(serializeBioContent(state.doc.slice(state.selection.from, state.selection.to).content)));

const BiographyInput = Extension.create({
  name: 'biographyInput', priority: 1000,
  addKeyboardShortcuts() {
    const enter = () => !this.editor.view.composing && availableBreaks(this.editor.state) === 0;
    return { Enter: enter, 'Shift-Enter': enter };
  },
  addProseMirrorPlugins() {
    return [new Plugin({
      // Covers virtual keyboard / DOM paragraph insertion as well as Enter.
      // Legacy descriptions remain editable while the author shortens them.
      filterTransaction: (tr, state) => !tr.docChanged
        || breaksIn(serializeBioDoc(tr.doc)) < CONTENT_LIMITS.aboutLines
        || breaksIn(serializeBioDoc(tr.doc)) <= breaksIn(serializeBioDoc(state.doc)),
      props: {
        transformPasted: slice => new Slice(Fragment.fromArray(bioPasteNodes(slice.content, this.editor.schema,
          availableBreaks(this.editor.state))), 0, 0),
      },
    })];
  },
});

export const bioExtensions = [
  StarterKit.configure({ bold: false, italic: false, strike: false, code: false, codeBlock: false,
    blockquote: false, heading: false, horizontalRule: false, bulletList: false, orderedList: false, listItem: false }),
  BiographyInput,
  ExternalLinkExtension.extend({ addNodeView() { return ReactNodeViewRenderer(BioLinkView); } }),
];
